module.exports = __webpack_public_path__ + "img/openedEye.cc654b33.svg";